import * as React from 'react';
import Button from '@mui/material/Button';

type SelectAllButtonLabels = {
    selectAllButton: string;
    deselectAllButton: string;
};

type SelectAllButtonProps = {
    labels: SelectAllButtonLabels;
    onClick: (showSelect: boolean) => void;
    disabled: boolean;
};

export function SelectAllButton({ labels, onClick, disabled }: SelectAllButtonProps) {
    let [showSelect, setShowSelect] = React.useState(true);

    function handleClick() {
        onClick(showSelect);
        setShowSelect((previous) => !previous);
    }

    return (
        <Button variant="contained" onClick={handleClick} disabled={disabled}>
            {showSelect ? labels.selectAllButton : labels.deselectAllButton}
        </Button>
    );
}
